import { PROGRESS_BAR_DEFAULT_VALUE } from './ProgressBar.constants'

import * as styles from './ProgressBar.module.css'

function ProgressBar({
  className = styles.ProgressBar,
  progress = PROGRESS_BAR_DEFAULT_VALUE,
}) {
  return (
    <div className={className} style={{ '--progress-bar-value': progress }} />
  )
}

export default ProgressBar
